<template>
  <div class="choice-wrapper">
    <label class="radio">
      <div class="wrap">
        <div v-if="isSelected" class="is-selected"></div>
      </div>
      <input
        :value="data"
        :name="name"
        type="radio"
        @change="onChange($event)"
      />
      <slot></slot>
    </label>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'AppRadio',
  props: {
    name: {
      required: true
    },
    value: {},
    data: {}
  },
  computed: {
    isSelected() {
      return this.value == this.data;
    }
  },
  methods: {
    onChange(event) {
      this.$emit('input', [event.target.value]);
    }
  }
};
</script>

<style lang="scss">
.radio {
  position: relative;
  input {
    opacity: 0;
    margin-right: 8px;
  }
  .wrap {
    position: absolute;
    width: 18px;
    height: 18px;
    top: 2px;
    left: 0;
    border: solid 1px $input-border-color;
    border-radius: 9px;
    font-size: 12px;
    padding: 4px;
    opacity: 1;
    .is-selected {
      width: 100%;
      height: 100%;
      border-radius: 20px;
      background: $primary;
    }
  }
}
</style>
